const Saxophone = require('./Saxophone');

Saxophone.parseAttrs = require('./static/attrs');
Saxophone.parseEntities = require('./static/entities');

module.exports = Saxophone;
